import React, { useEffect, useState } from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { Box, Fade, Stack, Typography } from '@mui/material';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';

function EnquirySuccess({ header, text, subText, transitionTime, animated }) {
  return (
    <Stack
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: animated ? '#f8e3dd' : '#4700d7',
        height: '100%',
        padding: '22px 12px',
        borderRadius: 2,
      }}
      direction='column'>
      <Box sx={{ color: animated ? '#1e0040' : '#fff', paddingRight: 4.25 }}>
        <Box
          sx={{
            mb: 2.5,
            width: 38,
            height: 38,
            border: '2px solid',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CheckRoundedIcon fontSize='medium' />
        </Box>
        <Typography
          variant='subtitle1'
          sx={{
            fontSize: 28,
            fontWeight: 700,
            lineHeight: 1,
            mb: 0.75,
          }}>
          {header}
        </Typography>
        <Typography
          variant='subtitle2'
          sx={{
            fontSize: 18,
            lineHeight: 1.25,
            mb: 1,
          }}>
          {text}
        </Typography>
        {subText && (
          <Typography
            variant='subtitle2'
            sx={{
              fontSize: 14,
              lineHeight: 1.3,
            }}>
            {subText}
          </Typography>
        )}
      </Box>
      {animated && (
        <Box
          sx={{
            background: `url(/images/confetti-transparent.gif) no-repeat center`,
            backgroundSize: 'cover',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: 'absolute',
            zIndex: 3,
            transform: 'rotate(-15deg)',
          }}
        />
      )}
      <Box sx={{ mt: 'auto' }}>
        <ProgressBar
          mainColor={animated ? '#ecafca' : '#c0a8ff'}
          transitionTime={transitionTime}
        />
      </Box>
    </Stack>
  );
}

const ProgressBar = ({ transitionTime, mainColor }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(oldProgress => {
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Fade
      in
      style={{
        transitionTime,
        transitionDelay: '10ms',
      }}
      unmountOnExit>
      <LinearProgress
        variant='determinate'
        value={progress}
        sx={{
          height: 5,
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: mainColor,
          },
          [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor: '#fff',
          },
        }}
      />
    </Fade>
  );
};

export default EnquirySuccess;
